import React, { useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Footer from '../Footer/Footer';
import { Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

function About(props) {
  const classes = useStyles();
  const sendEmail = (e) => {
    e.preventDefault();
    window.emailjs
      .sendForm(
        'default_service',
        'template_1ewbltc',
        e.target,
        'user_XOlCl0ufWTjmhLIBVREYN'
      )
      .then(
        (result) => {
          alert('Thank You. We will contact you soon')
          props.history.push("/")
        },
        (error) => {
          alert('Something went wrong. Please try after sometime')
        }
      );
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (1 === !1) return <Redirect to="/" />;
  return (
    <div>
      <div style={{ marginBottom: '0px', backgroundColor: 'rgb(1, 160, 90)' }}>
        <div
          className="container py-5"
          style={{ marginTop: '3.4em', marginBottom: '0px' }}
        >
          <div className="row h-100 align-items-center py-5">

            <div className="col-lg-5 d-none d-lg-block">
              <Paper elevation={3} style={{ padding: '4%', borderRadius: '20px' }} >
                <form className="contact-form" onSubmit={sendEmail}>
                  <input
                    type="text"
                    name="user_name"
                    placeholder="Your Fullname"
                  />
                  <input
                    type="text"
                    name="contact_number"
                    placeholder="Your Phone Number"
                  />
                  <input
                    type="email"
                    name="user_email"
                    placeholder="Your E-mail"
                  />
                  <input type="hidden" name="subject" placeholder="Subject" value="Merchant Enquiry email" />
                  <textarea
                    placeholder="Message"
                    name="message"
                    defaultValue={''}
                  />
                  <button
                    type="submit"
                    style={{
                      height: '45px',
                      paddingTop: '12px',
                      background: 'rgb(1, 160, 90)',
                      border: '1px solid rgb(1, 160, 90)',
                      color: '#fff',
                      borderRadius: '15px',
                    }}
                    className="btnAdd site-btn"
                  >
                    CONTACT NOW
                  </button>
                </form>
              </Paper>
            </div>
            <div className="col-lg-7">
              <Typography variant="h1" style={{ textAlign: "right", color: 'white', fontSize: "57px", fontWeight: "900" }}>ON DEMAND DELIVER SERVICES FOR YOUR BUSINESS</Typography>
              <Typography variant="h1" style={{ textAlign: "right", color: 'white', fontSize: "27px", fontWeight: "500" }}> <i>WE DELIVER BETTER FASTER AND CHEAPER</i></Typography>
              <Typography variant="h1" style={{ textAlign: "right", fontSize: "37px", fontWeight: "900", marginTop: "40px", color: "#303030" }}>Become a Merchant with Grospick</Typography>
              <Typography variant="h1" style={{ textAlign: "right", color: 'white', fontSize: "20px", fontWeight: "400" }}> Find out more about Grospick online ordering and delivery solutions below. Partner with us to grow your business.</Typography>

            </div>
          </div>
        </div>
      </div>
      <Typography variant="h1" style={{ textAlign: "center", fontSize: "32px", fontWeight: "900", marginTop: "3%" }}>A LOGISTIC SOLUTION FOR YOUR BUSINESS</Typography>
      <div className="bg-white py-5">
        <div className="container py-5">
          <div className="row align-items-center mb-5">
            <div className="col-lg-4 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/1.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-4 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/2.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-4 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/3.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-4">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center" }}>Scheduling</Typography>
            </div>
            <div className="col-lg-4">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center" }}>Multiple drop points</Typography>
            </div>
            <div className="col-lg-4">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center" }}>Live order support</Typography>
            </div>
          </div>
        </div>
        <div className="container py-5">
          <div className="row align-items-center mb-5">
            <div className="col-lg-4 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/4.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-4 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/5.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-4 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/6.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-4">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center" }}>Pay later</Typography>
            </div>
            <div className="col-lg-4">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center" }}>Live tracker</Typography>
            </div>
            <div className="col-lg-4">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center" }}>Available 24x7</Typography>
            </div>
          </div>
        </div>
      </div>
      <div className="py-5" style={{ backgroundColor: "#F5F5F5" }}>
        <Typography variant="h1" style={{ textAlign: "center", fontSize: "38px", fontWeight: "400", marginTop: "3%" }}>We deliver <b>FASTER</b>, <b>CHEAPER</b> and <b>BETTER</b></Typography>
        <div className="container py-5">
          <div className="row align-items-center mb-5">
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/7.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/8.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/9.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/10.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Reliable service</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Assured fulfillment</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Lighting fast deliveries</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Cost effective</Typography>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-5">
        <Typography variant="h1" style={{ textAlign: "center", fontSize: "38px", fontWeight: "800", marginTop: "3%" }}>Ways we help your business</Typography>
        <div className="container py-5">
          <div className="row align-items-center mb-5">
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/11.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/12.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/13.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/14.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Increase your revenue</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Reach out to a large customer base</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Access to the large delivery fleet</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Increase your brand visibility</Typography>
            </div>
          </div>
        </div>
      </div>
      <div className="py-5" style={{ backgroundColor: "#F5F5F5" }}>
        <Typography variant="h1" style={{ textAlign: "center", fontSize: "38px", fontWeight: "800", marginTop: "3%" }}>Place your order in 4 easy steps</Typography>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Step 1</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Step 2</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Step 3</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "18px" }}>Step 4</Typography>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/15.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/16.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/17.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-3 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/18.png"
                alt=""
                width="150"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "left", fontSize: "18px" }}>Choose the pickup and drop locations</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "left", fontSize: "18px" }}>Add any special instructions to your order</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "left", fontSize: "18px" }}>Review and pay for your order</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "left", fontSize: "18px" }}>All set! You can track your order while we complete it</Typography>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3">
              <Typography variant="h5" style={{ textAlign: "left", fontSize: "18px" }}>Add a new pickup and drop
                location or pick from your
                existing ones.</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" style={{ textAlign: "left", fontSize: "18px" }}>Add any delivery instructions,
                AWB number if you’d like. This
                is optional.</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" style={{ textAlign: "left", fontSize: "18px" }}>Check everything about
                your order before you
                place it and pay.</Typography>
            </div>
            <div className="col-lg-3">
              <Typography variant="h5" style={{ textAlign: "left", fontSize: "18px" }}>Stay worry-free as your
                delivery partner will take
                care of it.</Typography>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-5">
        <Typography variant="h1" style={{ textAlign: "center", fontSize: "38px", fontWeight: "800", marginTop: "3%" }}>Available in 5 suburbs in Australia</Typography>
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-4">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "28px" }}>Burwood</Typography>
            </div>
            <div className="col-lg-4">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "28px" }}>Strathfield</Typography>
            </div>
            <div className="col-lg-4">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "28px" }}>Homebush</Typography>
            </div>
          </div>
          <div className="row align-items-center mb-5">
            <div className="col-lg-4 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/19.png"
                alt=""
                width="200"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-4 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/20.png"
                alt=""
                width="200"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-4 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/21.png"
                alt=""
                width="200"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
          </div>

        </div>
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "28px" }}>Concord</Typography>
            </div>
            <div className="col-lg-6">
              <Typography variant="h5" className="font-weight-bold" style={{ textAlign: "center", fontSize: "28px" }}>Enfield</Typography>
            </div>
          </div>
          <div className="row align-items-center mb-5">
            <div className="col-lg-6 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/22.png"
                alt=""
                width="200"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
            <div className="col-lg-6 px-5 mx-auto order-1 order-lg-2">
              <img
                src="./img/merchant/23.png"
                alt=""
                width="200"
                className="img-fluid mb-4 mb-lg-0"
              />
            </div>
          </div>

        </div>
      </div>
      {/* <div className="py-5" style={{ backgroundColor: "rgb(29, 36, 60)" }}>
        <div className="container py-5">
          <div className="row align-items-center mb-5">
            <div className="col-lg-12 col-sm-12">
              <Typography variant="h4" style={{ textAlign: "left", color: 'white' }}>HOW TO GET STARTED</Typography>
            </div>
          </div>
          <div className="row align-items-center mb-5">
            <div className="col-lg-4 col-sm-4">
              <Typography variant="p" style={{ textAlign: "left", color: 'white', display: "flex", fontWeight: "bold" }}>Choose the pickup and drop locations</Typography>
            </div>
            <div className="col-lg-4 col-sm-4">
              <Typography variant="p" style={{ textAlign: "left", color: 'white', display: "flex", fontWeight: "bold" }}>Add any special instructions to your order</Typography>
            </div>
            <div className="col-lg-4 col-sm-4">
              <Typography variant="p" style={{ textAlign: "left", color: 'white', display: "flex", fontWeight: "bold" }}>Earn Money</Typography>
            </div>
            <br></br>
          </div>
        </div> */}
      {/* </div> */}
      {/* <div className="bg-white py-5">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <Typography variant="h4" className="font-weight-bold" style={{ textAlign: "left" }}>Questions</Typography>
            </div>
          </div>
          <br></br>
          <br></br>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>How do I earn money with Grospick</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    As an independent contractor you can earn money by making deliveries
                    via the Grospick platform. You are paid for deliveries done from our partner
                    merchants to our customers.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>When do I get paid?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    You will get paid on a weekly basis. We provide you with a detailed summary of
                    all the deliveries you complete and how much you made for each. This is
                    available via our app and courier portal.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
          <br></br>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>What equipment do I need?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography style={{ paddingLeft: '5%', textAlign: "left" }}>
                    As an independent contractor, you’re responsible for providing and
                    maintaining your own equipment including:
                    <ul>
                      <li>
                        Something to get around on a roadworthy car, motorbike or scooter,
                        registered and CTP insured. You’ll also need a full driver’s licence.
                      </li>
                      <li>Something to wear, while you can wear what you want, it’s very
                        important you provide an excellent impression to customers and
                        merchants alike. We’d like you to dress neatly and not wear clothing which
                        contain words/slogans which might oend. Also, safety is important and
                        you’ll need a strong helmet and protective clothing if you’re riding a
                        motorbike/scooter.
                      </li>
                      <li>Something compatible with our driver app, either ‘iOS’ or ‘Android’
                        mobile phone, a charger so your battery doesn’t run at and a data plan
                      </li>
                      <li>Something to to carry deliveries in,delivery quality is essential to us all.
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>Any vehicle requirements?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Your vehicle needs to be a 1990 model or newer, registered and CTP
                    insured. You also need a full driver’s license.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
          <br></br>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>How much money do I make?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    As an independent Grospick courier you earn money through your delivery
                    fee which is based o distance and driving time. This will all be explained
                    further as part of onboarding.

                    Unlike other services, Grospick does not take a commission on your fees -
                    you keep the money you make.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>How am I allocated deliveries?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Our advanced technology system matches your availability and location
                    with the exact time delivery will be ready to collect from one of the many
                    busy merchant partners – this makes the most ecient use of everyone’s
                    time and means on time deliveries.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
          <br></br>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>When can I get started?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    You can start making deliveries on our network once you complete the
                    signup process, provide all the correct documents, participate in a quick
                    screening call with a member of our team, and have all of the required
                    equipment.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="col-lg-6">
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>What does it mean to be an independent
                    contractor?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    As a courier on the Grospick network, it means you have the freedom to
                    choose when you can work, how often you work and how much you earn.
                    You are under no obligation to provide any services to us and you are also
                    free to work for other businesses.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </div>
      </div> */}
      <Footer />
    </div>
  );
}

export default About;
